import React from "react";
import { Tooltip as ShadcnTooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../shadcn/tooltip";

/**
* Tooltip (custom)
* ----------------
* Ths custom tooltip extends to Shadcn tooltip component.
*/

interface TooltipProps {
  children: React.ReactNode; // The trigger element
  text?: string;
  width?: string;
  delayDuration?: number;
}

const Tooltip: React.FC<TooltipProps> = ({ children, text, width, delayDuration = 200 }) => {
  return (
    <TooltipProvider>
      <ShadcnTooltip delayDuration={delayDuration}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent>
          <p className={`break-words font-normal space-normal text-white ${width ? width : ""}`}>{text}</p>
        </TooltipContent>
      </ShadcnTooltip>
    </TooltipProvider>
  );
};

export default Tooltip;
